import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from '../../../../../contexts/authContext';
import { useEffect, useRef, useState } from 'react';
import { AssistantMessage } from '../../../../../shared/types/assistant';
import { AssistantRule } from '../../../../../shared/types/assistant-rule';
import { SharepointItem } from '../../../../../shared/types/sharepoint';
import { useDropZoneField } from '../../../../components/general/fields/dropzoneField/hook';
import { asyncGetAssistantRules } from '../../../../../services/assistant-rule.service';
import {
    asyncDownloadFile,
    asyncGetChatAssistants,
} from '../../../../../services/chat-assistant.service';
import {
    createTendersAssistant,
    updateTendersAssistant,
} from '../../../../../services/assistant/tender-assistant.use-case';
import { fileToBase64 } from '../../../../../shared/utils/files';
import variables from '../../../../../shared/styles/settings.module.scss';
import { LICITACIONES_NEW } from '../../../../../routes/paths';
import { styled } from '@mui/material';
import {
    asyncModifyCalendar,
    asyncGetTender,
} from '../../../../../services/tender.service';
import { getPreviousMessageUseCase } from '../../../../../services/assistant/get-message.use-case';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import Swal from 'sweetalert2';
import { User } from '../../../../../shared/types/user';
import { asyncGetUsersSimple } from '../../../../../services/users.service';
import { asyncAssignUsers } from '../../../../../services/tender.service';
import dayjs, { Dayjs } from 'dayjs';

export const useTenderChatHook = () => {
    const navigate = useNavigate();
    const { idTender } = useParams();
    const { modeTheme } = useAuthContext();
    const [correctChecklist, setCorrectCheckList] = useState(false);
    const [isSendedCorrectedChecklist, setIsSendedCorrectedChecklist] =
        useState(false);
    const [isAnalizeFile, setIsAnalizeFile] = useState(false);
    const [isOnlyView, setIsOnlyView] = useState(false);
    const [messages, setMessages] = useState<AssistantMessage[]>([
        {
            isGpt: true,
            content: [
                {
                    text: {
                        value: 'Buenos días, soy Victoria, asistente de Licitaciones. ¿Deseas registrar una nueva licitación o consultar una existente?',
                    },
                    type: 'text',
                },
            ],

            time: new Date().toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
            }),
            id: '1',
        },
    ]);
    const [quickOpen, setQuickOpen] = useState(false);
    const [presets, setPresets] = useState<Record<string, AssistantRule[]>>({});
    const [threadId, setThreadId] = useState('');
    const [isOpenModal, setIsOpenModal] = useState(false);
    const scrollRef = useRef<HTMLDivElement>(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [openOptionButton, setOpenOptionButton] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [sharepointModalOpen, setSharepointModalOpen] = useState(false);
    const [isSharepointAuth, setIsSharepointAuth] = useState(false);
    const [isOpenModalFiles, setIsOpenModalFiles] = useState(false);
    const [isOpenUsersModal, setIsOpenUsersModal] = useState(false);
    const [isOpenCalendarModal, setIsOpenCalendarModal] = useState(false);
    const [fechas, setFechas] = useState<FechasType>({
        fechaObservacionPrepliegos: null,
        fechaRespuestasPrepliegos: null,
        fechaPublicacionPliegosDefinitivos: null,
        fechaObservacionesDefinitivos: null,
        fechaRespuestasDefinitivos: null,
        fechaPresentacionOferta: null,
        fechaPublicacionPrimerInforme: null,
        fechaObservacionesSubsancionInforme: null,
        fechaSubastaAudiencia: null,
    });
    const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
    const [users, setUsers] = useState<User[]>([]);
    const [sharepointItems, setSharepointItems] = useState<SharepointItem[]>(
        []
    );

    const openSharepointSelector = () => {
        setSharepointItems([]);
        setSharepointModalOpen(true);
    };

    const acceptedFiles = '.xlsx , .doc, .docx, .pdf';
    const { updateFiles, files } = useDropZoneField({
        accept: acceptedFiles,
        maxFileSize: 10 * 1024 * 1024,
    });

    const analyzeAndSendMessage = async (
        items: any[],
        source: 'local' | 'sharepoint' = 'local'
    ) => {
        if (!items?.length) return;

        const data: any[] = [];

        if (source === 'local') {
            for await (const item of items) {
                const file = item?.file ?? item;
                const res = await fileToBase64(file);
                if (res) data.push(res);
            }
        } else {
            items.forEach((f) =>
                data.push({
                    id: f.id,
                    name: f.name,
                    isSharepoint: true,
                    isFolder: !!f.folder,
                    driveId: f?.parentReference?.driveId || f?.driveId,
                })
            );
        }

        const message = 'Analizar archivo(s)';
        sendMessage(message, data);
        setIsOpenModalFiles(false);
        setSharepointModalOpen(false);
    };

    const validateChecklist = (modeTheme: string) => {
        const iconColor =
            modeTheme === 'darkMode'
                ? variables.darkColor
                : variables.primaryColor;

        Swal.fire({
            title: 'Aprobación del checklist',
            text: '¿Deseas aprobar el checklist tal como está o prefieres hacer correcciones?',
            icon: 'question',
            iconColor,
            showDenyButton: true,
            confirmButtonText: 'Aprobar sin cambios',
            confirmButtonColor: iconColor,
            denyButtonText: 'Hacer correcciones',
            denyButtonColor: iconColor,
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                setCorrectCheckList(false);
                sendMessage('Aprobar checklist');
            } else if (response.isDenied) {
                setCorrectCheckList(true);
                sendMessage('Quiero corregir el checklist');
            }
        });
    };

    const sendMessage = async (text: string, files: any[] = []) => {
        console.log('isAnalizeFile', isAnalizeFile);
        let finalText = text;

        if (finalText === 'Abrir análisis del pliego') {
            setIsAnalizeFile(true);
        }

        if (isAnalizeFile && files.length > 0) {
            console.log('Generar resumen pliego');
            finalText = 'Generar resumen pliego';
            setIsAnalizeFile(false);
        }

        if (
            (correctChecklist && !isSendedCorrectedChecklist) ||
            (messages &&
                messages[0]?.content[0]?.text?.value
                    ?.toLowerCase()
                    ?.includes('Agregar más archivos'))
        ) {
            finalText = `Check list corregido: ${text}`;
        }
        const now = new Date();
        const time = now.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
        });

        const tempId = 'temp-';
        Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

        const attachedFilesText = files.length
            ? `\n\nArchivos adjuntos:\n${files
                .map((f) => `• ${f.name}`)
                .join('\n')}`
            : '';
        setMessages((prev) => [
            ...prev,
            {
                id: tempId + '-user',
                isGpt: false,
                content: [
                    {
                        type: 'text',
                        text: {
                            value: `${
                                (correctChecklist && files.length > 0) ||
                                (isAnalizeFile && files.length > 0)
                                    ? finalText
                                    : text
                            }${attachedFilesText}`,
                        },
                    },
                ],
                time,
            },
            {
                id: tempId,
                isGpt: true,
                temp: true,
                content: [],
                time,
            },
        ]);

        setIsLoading(true);
        let assistantResponse;

        if (!idTender) {
            assistantResponse = await createTendersAssistant(
                threadId,
                text,
                files
            );
        } else {
            assistantResponse = await updateTendersAssistant(
                threadId,
                finalText,
                idTender,
                files
            );
        }
        setIsLoading(false);

        const lastMessage = assistantResponse?.message?.at(-1)?.content?.[0];

        let parsedText: any = null;

        try {
            if (assistantResponse?.arguments) {
                parsedText = JSON.parse(assistantResponse.arguments as string);
            }
        } catch {
            parsedText = null;
        }

        const reply =
            lastMessage?.text?.value ||
            parsedText?.text ||
            'Ocurrió un error procesando la solicitud, inténtalo nuevamente';

        const fileOutputs = lastMessage?.fileOutputs;
        let filteredResponse: unknown;

        try {
            const parsed = JSON.parse(reply);
            filteredResponse = parsed?.text ?? parsed;
        } catch {
            filteredResponse = reply;
        }

        const newThreadId = assistantResponse?.threadId ?? threadId;
        setThreadId(newThreadId);

        if (assistantResponse?.action === 'create_new_tender') {
            setIsOpenModal(true);
            navigate(LICITACIONES_NEW);
        } else if (assistantResponse?.action === 'upload_document') {
            setIsOpenModalFiles(true);
        } else if (assistantResponse?.action === 'checklist_review') {
            validateChecklist(modeTheme);
        }

        setMessages((prev) => {
            const updated = [...prev];
            const reversedIndex = [...updated]
                .reverse()
                .findIndex((msg) => msg.temp);
            const index =
                reversedIndex !== -1 ? updated.length - 1 - reversedIndex : -1;

            if (index !== -1) {
                updated[index] = {
                    ...updated[index],
                    isGpt: true,
                    temp: false,
                    content: [
                        {
                            type: 'text',
                            text: { value: filteredResponse as string },
                            fileOutputs,
                        },
                    ],
                    time: new Date().toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit',
                    }),
                };
            }

            if (correctChecklist && !isSendedCorrectedChecklist) {
                setIsSendedCorrectedChecklist(true);
            }
            return updated;
        });
    };

    const onClickDownload = async (contentItem: any) => {
        const assistant = await asyncGetChatAssistants({
            name: 'Asistente de licitaciones',
            apiIntegration: true,
        });

        const result = await asyncDownloadFile(
            assistant?.items[0]?.id as string,
            contentItem.id as string,
            threadId as string
        );
        if (result) {
            const { url, filename } = result;
            const link = document.createElement('a');
            link.href = url;
            link.download = filename || 'archivo.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
        }
    };

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
    });

    const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = e.target.files;
        if (!fileList) return;
        const incomingFiles = Array.from(fileList).map((file, index) => ({
            id: Date.now() + index,
            file,
        }));
        updateFiles(incomingFiles);
        e.target.value = '';
        analyzeAndSendMessage(incomingFiles, 'local');
    };

    const handleAssignUsers = async () => {
        if (!idTender) return;

        try {
            await asyncAssignUsers(
                idTender,
                selectedUsers.map((u) => u.id)
            );

            ToastSwal.fire({
                text: 'Usuarios asignados correctamente',
                icon: 'success',
                timer: 2000,
            });

            setIsOpenUsersModal(false);
        } catch (error) {
            ToastSwal.fire({
                text: 'Error al asignar usuarios',
                icon: 'error',
            });
        }
    };

    const handleModifyCalender = async () => {
        if (!idTender) return;
        try {
            // convertir dayjs a date
            const formatted = Object.fromEntries(
                Object.entries(fechas).map(([key, value]) => [
                    key,
                    value ? value.toDate() : null,
                ])
            );
            await asyncModifyCalendar(idTender, formatted);

            ToastSwal.fire({
                text: 'Caledario actualizado Correctamente',
                icon: 'success',
                timer: 2000,
            });

            setIsOpenCalendarModal(false);
        } catch (error) {
            ToastSwal.fire({
                text: 'Error al actualizar el calendario',
                icon: 'error',
            });
        }
    };

    const refreshMessages = async () => {
        if (!threadId) return;

        try {
            const replies = await getPreviousMessageUseCase(threadId);

            const msgs: AssistantMessage[] = (replies ?? []).map((reply) => ({
                id: reply.id,
                isGpt: reply.role === 'assistant',
                content: (reply.content ?? []).map((c: any) => ({
                    type: c.type,
                    text: { value: c.text?.value ?? '' },
                    fileOutputs: c.fileOutputs ?? [],
                })),
                time: new Date(reply.created_at).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit',
                }),
            }));

            setMessages(msgs);
        } catch (e) {
            ToastSwal.fire({
                text: 'Error obteniendo nuevos mensajes',
                icon: 'error',
                timer: 3000,
                position: 'center-end',
            });
        }
    };

    type FechasType = {
        fechaObservacionPrepliegos: Dayjs | null;
        fechaRespuestasPrepliegos: Dayjs | null;
        fechaPublicacionPliegosDefinitivos: Dayjs | null;
        fechaObservacionesDefinitivos: Dayjs | null;
        fechaRespuestasDefinitivos: Dayjs | null;
        fechaPresentacionOferta: Dayjs | null;
        fechaPublicacionPrimerInforme: Dayjs | null;
        fechaObservacionesSubsancionInforme: Dayjs | null;
        fechaSubastaAudiencia: Dayjs | null;
    };

    type CalendarField = {
        key: keyof FechasType;
        label: string;
    };

    const calendarFields: CalendarField[] = [
        {
            key: 'fechaObservacionPrepliegos',
            label: 'Fecha Observaciones Prepliegos',
        },
        {
            key: 'fechaRespuestasPrepliegos',
            label: 'Fecha Respuestas Prepliegos',
        },
        {
            key: 'fechaPublicacionPliegosDefinitivos',
            label: 'Fecha Publicación Pliegos Definitivos',
        },
        {
            key: 'fechaObservacionesDefinitivos',
            label: 'Fecha Observaciones Definitivos',
        },
        {
            key: 'fechaRespuestasDefinitivos',
            label: 'Fecha Respuestas Definitivos',
        },
        {
            key: 'fechaPresentacionOferta',
            label: 'Fecha Presentación Oferta',
        },
        {
            key: 'fechaPublicacionPrimerInforme',
            label: 'Fecha Publicación Primer Informe',
        },
        {
            key: 'fechaObservacionesSubsancionInforme',
            label: 'Fecha Observaciones Subsanación Informe',
        },
        {
            key: 'fechaSubastaAudiencia',
            label: 'Fecha Subasta Audiencia',
        },
    ];

    let keyOptions = ['Nueva licitación'];

    if (idTender) {
        keyOptions = [
            'Abrir análisis del pliego',
            'Generar check list',
            'Aprobar o corregir check list',
            'Generar ZIP',
        ];
    }

    useEffect(() => {
        asyncGetAssistantRules()
            .then((res) => setPresets(res))
            .catch(() => {
                return {};
            });
    }, []);

    useEffect(() => {
        if (scrollRef.current)
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }, [messages]);

    useEffect(() => {
        if (
            isOpenModalFiles &&
            sharepointItems.length > 0 &&
            !sharepointModalOpen
        ) {
            analyzeAndSendMessage(sharepointItems, 'sharepoint');
        }
    }, [sharepointItems, sharepointModalOpen, isOpenModalFiles]);

    useEffect(() => {
        const fetchPreviousMessages = async () => {
            if (!threadId && idTender) {
                const tender = await asyncGetTender(idTender);

                if (tender?.threadId) {
                    setThreadId(tender.threadId);
                }
            }

            try {
                if (threadId) {
                    const replies = await getPreviousMessageUseCase(threadId);
                    const msgs: AssistantMessage[] = (replies ?? []).map(
                        (reply) => ({
                            id: reply.id,
                            isGpt: reply.role === 'assistant',
                            content: (reply.content ?? []).map((c: any) => ({
                                type: c.type,
                                text: { value: c.text?.value ?? '' },
                                fileOutputs: c.fileOutputs ?? [],
                            })),
                            time: new Date(reply.created_at).toLocaleTimeString(
                                [],
                                {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                }
                            ),
                        })
                    );
                    setMessages(msgs);
                }
            } catch (err) {
                ToastSwal.fire({
                    text: 'Ocurrió un error al cargar la licitación.',
                    icon: 'error',
                    timer: 5000,
                    position: 'center-end',
                });
            }
        };
        fetchPreviousMessages();
    }, [threadId, idTender]);

    useEffect(() => {
        if (!threadId || isLoading) return;

        const interval = setInterval(() => {
            refreshMessages();
        }, 30_000);

        return () => clearInterval(interval);
    }, [threadId, isLoading]);

    useEffect(() => {
        if (!isOpenUsersModal || !idTender) return;
        const loadUsers = async () => {
            const response = await asyncGetUsersSimple();
            const allUsers = response?.items || [];
            setUsers(response.items);

            const tender = await asyncGetTender(idTender);

            if (tender?.users) {
                const matchedUsers = allUsers.filter((u) =>
                    tender.users?.some((tu) => tu.id === u.id)
                );
                setSelectedUsers(matchedUsers);
            }
        };

        loadUsers();
    }, [isOpenUsersModal]);

    useEffect(() => {
        if (!isOpenCalendarModal || !idTender) return;

        const loadCalendar = async () => {
            try {
                const tender = await asyncGetTender(idTender);

                if (tender?.calendar) {
                    const formatted = Object.fromEntries(
                        Object.entries(tender.calendar).map(([key, value]) => [
                            key,
                            value ? dayjs(value as string) : null,
                        ])
                    );

                    setFechas(formatted as FechasType);
                }
            } catch (error) {
                ToastSwal.fire({
                    text: 'Error al cargar el calendario',
                    icon: 'error',
                });
            }
        };

        loadCalendar();
    }, [isOpenCalendarModal, idTender]);

    return {
        quickOpen,
        setQuickOpen,
        scrollRef,
        messages,
        onClickDownload,
        isLoading,
        keyOptions,
        sendMessage,
        selectedIndex,
        openOptionButton,
        setOpenOptionButton,
        setSelectedIndex,
        sharepointItems,
        setSharepointItems,
        files,
        presets,
        isOpenModal,
        setIsOpenModal,
        threadId,
        isOpenModalFiles,
        setIsOpenModalFiles,
        acceptedFiles,
        handleFileInputChange,
        isSharepointAuth,
        setIsSharepointAuth,
        sharepointModalOpen,
        setSharepointModalOpen,
        VisuallyHiddenInput,
        openSharepointSelector,
        idTender,
        isOnlyView,
        setIsOnlyView,
        isOpenUsersModal,
        setIsOpenUsersModal,
        selectedUsers,
        setSelectedUsers,
        users,
        handleAssignUsers,
        isOpenCalendarModal,
        setIsOpenCalendarModal,
        fechas,
        setFechas,
        calendarFields,
        handleModifyCalender,
    };
};
